import { createAction } from '@reduxjs/toolkit';
export const getIncidents = createAction('stylovyze/incidents/getIncidents');
export const getIncidentsResolved = createAction('stylovyze/incidents/getIncidents/resolved');
export const getIncidentsRejected = createAction('stylovyze/incidents/getIncidents/rejected');
export const addAlertToIncident = createAction('stylovyze/incidents/addAlertToIncident');
export const addAlertToIncidentResolved = createAction('stylovyze/incidents/addAlertToIncident/resolved');
export const addAlertToIncidentRejected = createAction('stylovyze/incidents/addAlertToIncident/rejected');
export const getIncidentByAlertId = createAction('stylovyze/incidents/getIncidentByAlertId');
export const getIncidentByAlertIdResolved = createAction('stylovyze/incidents/getIncidentByAlertId/resolved');
export const getIncidentByAlertIdRejected = createAction('stylovyze/incidents/getIncidentByAlertId/rejected');
